import React from 'react';
import Image from 'assets/boxes.png';
import { UndraggableImage } from 'components/shared/UndraggableImage';

export const BoxesImage = React.memo(() => {
  return (
    <UndraggableImage
      src={Image}
      maxWidth={{ base: 100, md: 200 }}
      objectFit="contain"
    />
  );
});
